import React from "react";
import HeaderNav from "../../header/header";
import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Layout,
    message,
    Row,
    Select,
    Space,
    Table,
    Spin, Modal
} from "antd";
import moment from 'moment';
import EditableTable from "./editTable";
import "../css/SingleCreateFinancialClaim.css"
import {basic_info, claims_save_local} from "../../../requist";
import * as XLSX from 'xlsx';
import ExportJsonExcel from 'js-export-excel';
import {claims_search,claims_save_ecc} from "../../../requist";

const { Content } = Layout;
const { Option } = Select;

class SingleFinancialClaimSearch extends React.Component{
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state={
            selectedRows:[],
            basic_info:'',
            file:null,
            dataSource:[],
            finishValues:null,
            errorData:[],
            errorDataTable:false,
            randomNumber:null,
            allData:[],
            uploadData:[],
            diffDaysError:false,
            loading:false,
            isModalVisible:false,
            disabled:false
        }
    }
    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }else{
            basic_info(false).then((res)=>{
                let {data,retCode,retMsg} = res;
                if(retCode==="200"){
                    window.sessionStorage.setItem('basic_info', JSON.stringify(res.data))
                    this.setState({basic_info:data})
                }else{
                    message.warn(`${retMsg}`)
                }
            })
        }
    }
    onImportExcel = file => {
        // 获取上传的文件对象
        const files = file;
        // 通过FileReader对象读取文件
        const fileReader = new FileReader();
        fileReader.onload = event => {
            try {
                const { result } = event.target;
                // 以二进制流方式读取得到整份excel表格对象
                const workbook = XLSX.read(result, { type: 'binary' });
                let data = []; // 存储获取到的数据
                // 遍历每张工作表进行读取（这里默认只读取第一张表）
                for (const sheet in workbook.Sheets) {
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        // 利用 sheet_to_json 方法将 excel 转成 json 数据
                        data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        // console.log(data[0])
                        // break; // 如果只取第一张表，就取消注释这行
                    }
                }
                this.setState({uploadData:data})
                data.length && data.map((item)=>{
                    Object.keys(item).forEach(key=>{
                        switch(key){
                            case 'Processing log':
                                item["processingLog"]=item[key]
                                delete item[key]
                                break
                            case 'Bill To Party':
                                item["billTo"]=item[key]
                                delete item[key]
                                break
                            case 'BP-Reference':
                                item["bpRef"]=item[key]
                                delete item[key]
                                break
                            case 'Changed On':
                                item["portalChangedAt"]=item[key]
                                delete item[key]
                                break
                            case 'Claim Category':
                                item["claimCategory"]=item[key]
                                delete item[key]
                                break
                            case 'Claim Value':
                                item["claimValue"]=item[key]
                                delete item[key]
                                break
                            case 'Unit Claim Value':
                                item["unitClaimValue"]=item[key]
                                delete item[key]
                                break
                            case 'Comment':
                                item["comment"] = item[key]
                                delete item[key]
                                break
                            case 'Channel':
                                item["channel"] = item[key]
                                delete item[key]
                                break
                            case 'Claim Item No.':
                                item["claimReqItem"] = item[key]
                                delete item[key]
                                break
                            case 'Claim ID':
                                item["claimId"] = item[key]
                                delete item[key]
                                break
                            case 'Contact Person':
                                item["contactPerson"]=item[key]
                                delete item[key]
                                break
                            case 'Currency':
                                item["currency"]=item[key]
                                delete item[key]
                                break
                            case 'City':
                                item["city"]=item[key]
                                delete item[key]
                                break
                            case 'Claim Request No.':
                                item["claimReqNo"]=item[key]
                                delete item[key]
                                break
                            case 'Claim Type':
                                item["claimType"]=item[key]
                                delete item[key]
                                break
                            case 'Country':
                                item["country"]=item[key]
                                delete item[key]
                                break
                            case 'Created On':
                                item["createdAt"]=item[key]
                                delete item[key]
                                break
                            case 'Created by':
                                item["createdBy"]=item[key]
                                delete item[key]
                                break
                            case 'Customer PO No.':
                                item["poNumber"]=item[key]
                                delete item[key]
                                break
                            case 'Changed By':
                                item["portalChangedBy"]=item[key]
                                delete item[key]
                                break
                            case 'Deletion Indicator':
                                item["deleteStatus"]=item[key]
                                delete item[key]
                                break
                            case 'Dispute No.':
                                item["disputeNo"]=item[key]
                                delete item[key]
                                break
                            case 'Dispute Item No.':
                                item["disputeItemNo"]=item[key]
                                delete item[key]
                                break
                            case 'Division':
                                item["division"]=item[key]
                                delete item[key]
                                break
                            case 'Email':
                                item["email"]=item[key]
                                delete item[key]
                                break
                            case 'End User Name':
                                item["endUserName"]=item[key]
                                delete item[key]
                                break
                            case 'Invoice No.':
                                item["invoiceNo"]=item[key]
                                delete item[key]
                                break
                            case 'Material':
                                item["partNumber"]=item[key]
                                delete item[key]
                                break
                            case 'Phone Number':
                                item["phoneNumber"]=item[key]
                                delete item[key]
                                break
                            case 'Portal Claim Request ID':
                                item["portalReqNo"]=item[key]
                                delete item[key]
                                break
                            case 'Portal Claim Request Item No.':
                                item["portalReqItem"]=item[key]
                                delete item[key]
                                break
                            case 'Postal Code':
                                item["postalCode"]=item[key]
                                delete item[key]
                                break
                            case 'Pricing Date':
                                item["pricingDate"]=item[key]
                                delete item[key]
                                break
                            case 'Quantity':
                                item["quantity"]=item[key]
                                delete item[key]
                                break
                            case 'Requested Delivery Date':
                                item["reqDeliveryDate"]=item[key]
                                delete item[key]
                                break
                            case 'SBO-No/SOP Ref./LENOVO Ref':
                                item["lenovoRef"]=item[key]
                                delete item[key]
                                break
                            case 'Sales Office':
                                item["salesOffice"]=item[key]
                                delete item[key]
                                break
                            case 'Sales Org':
                                item["salesOrg"]=item[key]
                                delete item[key]
                                break
                            case 'Serial Number':
                                item["serialNumber"]=item[key]
                                delete item[key]
                                break
                            case 'Ship To Party':
                                item["shipTo"]=item[key]
                                delete item[key]
                                break
                            case 'Sold To Party':
                                item["soldTo"]=item[key]
                                delete item[key]
                                break
                            case 'Status':
                                item["claimReqStatus"]=item[key]
                                delete item[key]
                                break
                            case 'Street/House Number':
                                item["street"]=item[key]
                                delete item[key]
                                break
                            case 'Street 2':
                                item["street2"]=item[key]
                                delete item[key]
                                break
                        }
                    })
                })
                let errorDataArray=[]
                data.length && this.setState({dataSource:data.map((item,index)=>{
                        if(item.claimReqNo){
                            if(!item.claimReqNo){
                                errorDataArray.push({line:index+1,name:'Claim Request No',des:'Claim Request No is Mandatory!'})
                            }
                            if(!item.claimId){
                                errorDataArray.push({line:index+1,name:'Claim ID',des:'Claim ID No is Mandatory!'})
                            }
                            if(!item.claimReqItem){
                                errorDataArray.push({line:index+1,name:'Claim Item No',des:'Claim Item No is Mandatory!'})
                            }
                        }
                        if(!item.portalReqNo){
                            errorDataArray.push({line:index+1,name:'Portal Claim Request ID',des:'Portal Claim Request ID No is Mandatory!'})
                        }
                        if(!item.portalReqItem){
                            errorDataArray.push({line:index+1,name:'Portal Claim Request Item No',des:'Portal Claim Request Item No is Mandatory!'})
                        }
                        if(!item.disputeNo){
                            errorDataArray.push({line:index+1,name:'Dispute No',des:'Dispute No is Mandatory!'})
                        }
                        if(!item.disputeItemNo){
                            errorDataArray.push({line:index+1,name:'Dispute Item No',des:'Dispute Item No is Mandatory!'})
                        }
                        if(!item.soldTo){
                            errorDataArray.push({line:index+1,name:'Sold To Party',des:'Sold To Party is Mandatory!'})
                        }
                        if(!item.billTo){
                            errorDataArray.push({line:index+1,name:'Bill To Party',des:'Bill To Party is Mandatory!'})
                        }
                        if(!item.claimType){
                            errorDataArray.push({line:index+1,name:'Claim Type',des:'Claim Type is Mandatory!'})
                        }
                        if(!item.claimCategory){
                            errorDataArray.push({line:index+1,name:'Claim Category',des:'Claim Category is Mandatory!'})
                        }
                        if(!item.salesOrg){
                            errorDataArray.push({line:index+1,name:'Sales Org',des:'Sales Org is Mandatory!'})
                        }
                        if(!item.salesOffice){
                            errorDataArray.push({line:index+1,name:'Sales Office',des:'Sales Office is Mandatory!'})
                        }
                        if(!item.pricingDate){
                            errorDataArray.push({line:index+1,name:'Pricing Date',des:'Pricing Date is Mandatory!'})
                        }
                        if(!item.channel){
                            errorDataArray.push({line:index+1,name:'Channel',des:'Channel is Mandatory!'})
                        }
                        if(!item.division){
                            errorDataArray.push({line:index+1,name:'Division',des:'Division is Mandatory!'})
                        }
                        if(!item.currency){
                            errorDataArray.push({line:index+1,name:'Currency',des:'Currency is Mandatory!'})
                        }
                        if(!item.partNumber){
                            errorDataArray.push({line:index+1,name:'Material',des:'Material is Mandatory!'})
                        }
                        if(!item.quantity){
                            errorDataArray.push({line:index+1,name:'Quantity',des:'Quantity is Mandatory!'})
                        }
                        if(!item.unitClaimValue){
                            errorDataArray.push({line:index+1,name:'Unit Claim Value',des:'Unit Claim Value is Mandatory!'})
                        }
                        return item = {id:item.portalReqNo+item.portalReqItem,...item}
                    }),randomNumber:Math.random()})
                    errorDataArray.length && this.setState({errorData:errorDataArray,errorDataTable:true})
            } catch (e) {
                message.error('The file type is incorrect');
                return;
            }
        };
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(new Blob([files]));
    }
    UploadProps=()=>{
        let that = this
        return {
            beforeUpload(file,fileList){
                return false
            },
            onChange({ file, fileList }) {
                if (file.status !== 'uploading') {
                    // console.log(file, fileList[0]);
                    // console.log(new Blob([file]))
                    that.onImportExcel(file)
                }
            },
        };
    }
    downloadExcel = () => {
        const data = this.state.dataSource ? this.state.dataSource : '';//表格数据
        var option={};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if(data){
                    // console.log(data)
                    let obj = {
                        'Portal Claim Request ID': data[i].portalReqNo,
                        'Portal Claim Request Item No.': data[i].portalReqItem,
                        'Claim Request No.': data[i].claimReqNo,
                        'Claim ID': data[i].claimId,
                        'Claim Item No.': data[i].claimReqItem,
                        'Dispute No.': data[i].disputeNo,
                        'Dispute Item No.': data[i].disputeItemNo,
                        'Sold To Party': data[i].soldTo,
                        'Customer Name': data[i].soldToText,
                        'Bill To Party': data[i].billTo,
                        'Ship To Party': data[i].shipTo,
                        'Invoice No.': data[i].invoiceNo,
                        'Claim Type': data[i].claimType,
                        'Order Reason Description': data[i].OrderReasonDescription,
                        'Claim Category': data[i].claimCategory,
                        'Sales Org': data[i].salesOrg,
                        'Sales Office': data[i].salesOffice,
                        'Pricing Date': data[i].pricingDate,
                        'Requested Delivery Date': data[i].reqDeliveryDate,
                        'Channel': data[i].channel,
                        'Division': data[i].division,
                        'Currency': data[i].currency,
                        'SBO-No/SOP Ref./LENOVO Ref': data[i].lenovoRef,
                        'BP-Reference': data[i].bpRef,
                        'Customer PO No.': data[i].poNumber,
                        'Street/House Number': data[i].street,
                        'Street 2': data[i].street2,
                        'Country': data[i].country,
                        'Postal Code': data[i].postalCode,
                        'City': data[i].city,
                        'Contact Person': data[i].contactPerson,
                        'Email': data[i].email,
                        'Phone Number': data[i].phoneNumber,
                        'Billing Instruction': data[i].billingInstruction,
                        'Comment': data[i].comment,
                        'Material': data[i].partNumber,
                        'Quantity': data[i].quantity,
                        'End User Name': data[i].endUserName,
                        'Unit Claim Value': data[i].unitClaimValue,
                        'Claim Value': data[i].claimValue,
                        'Serial Number': data[i].serialNumber,
                        'Deletion Indicator': data[i].deleteStatus,
                        'Created On': data[i].createdAt,
                        'Created by': data[i].createdBy,
                        'Changed On': data[i].portalChangedAt,
                        'Changed By': data[i].portalChangedBy,
                        'Status': data[i].claimReqStatus,
                        'Processing log': data[i].processingLog,
                    }
                    dataTable.push(obj);
                }
            }
        }
        option.fileName = 'data'
        option.datas=[
            {
                sheetData:dataTable,
                sheetName:'sheet',
                // sheetFilter:['portalReqNo'],
                sheetHeader:[
                    'Portal Claim Request ID','Portal Claim Request Item No.','Dispute No.','Dispute Item No.',
                    'Claim Request No.','Claim ID','Claim Item No.','Sold To Party',
                    'Customer Name','Bill To Party','Ship To Party','Invoice No.','Claim Type',
                    'Order Reason Description','Claim Category','Sales Org','Sales Office','Channel','Division',
                    'Pricing Date', 'Requested Delivery Date','SBO-No/SOP Ref./LENOVO Ref',
                    'BP-Reference','Customer PO No.','Street/House Number','Street 2','Country','Postal Code',
                    'City','Contact Person','Email','Phone Number','Billing Instruction','Comment',
                    'Material','Quantity','End User Name','Unit Claim Value','Claim Value','Currency',
                    'Serial Number', 'Deletion Indicator','Created On','Created by','Changed On','Changed By',
                    'Status', 'Processing log'
                ],
            }
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
    }
    onEccSave=()=>{
        let {selectedRows,errorData,errorDataTable,uploadData,allData,dataSource} = this.state
        let userId = window.localStorage.getItem('userId')
        let MandatoryData=true
        this.setState({loading:true})
        if(selectedRows.length){
            selectedRows.map((item,index)=>{
                item.createdBy=userId;
                    if(item.reqDeliveryDate){
                        item.reqDeliveryDate = moment(item.reqDeliveryDate).format('YYYY-MM-DD')
                    }
                    if(item.pricingDate){
                        item.pricingDate = moment(item.pricingDate).format('YYYY-MM-DD')
                    }
                    if(item.unitClaimValue<=0){
                        MandatoryData=false
                        message.warn('Claim quantity and Unit claim value should be bigger than zero!')
                    }
                    // if(!item.claimReqNo){
                    //     MandatoryData=false
                    //     message.warn('Claim Request No is required')
                    // }
                    if(!item.comment){
                        MandatoryData=false
                        message.warn('Comment is required')
                    }
                    // if(!item.claimId){
                    //     MandatoryData=false
                    //     message.warn('Claim ID is required')
                    // }
                    // if(!item.claimItemNo){
                    //     MandatoryData=false
                    //     message.warn('Claim Item No is required')
                    // }
                    if(!item.portalReqNo){
                        MandatoryData=false
                        message.warn('Portal Claim Request ID is required')
                    }
                    if(!item.portalReqItem){
                        MandatoryData=false
                        message.warn('Portal Claim Request Item No is required')
                    }
                    if(!item.disputeNo){
                        MandatoryData=false
                        message.warn('Dispute No is required')
                    }
                    if(item.massUpload==='X'){

                    }else{
                        if(!item.disputeItemNo){
                            MandatoryData=false
                            message.warn('Dispute Item No is required')
                        }
                    }
                    if(!item.soldTo){
                        MandatoryData=false
                        message.warn('Sold To Party is required')
                    }
                    if(!item.billTo){
                        MandatoryData=false
                        message.warn('Bill To Party is required')
                    }
                    if(!item.claimType){
                        MandatoryData=false
                        message.warn('Claim Type is required')
                    }
                    if(!item.claimCategory){
                        MandatoryData=false
                        message.warn('Claim Category is required')
                    }
                    if(!item.salesOrg){
                        MandatoryData=false
                        message.warn('Sales Org is required')
                    }
                    if(!item.salesOffice){
                        MandatoryData=false
                        message.warn('Sales Office is required')
                    }
                    if(!item.pricingDate){
                        MandatoryData=false
                        message.warn('Pricing Date is required')
                    }
                    if(!item.channel){
                        MandatoryData=false
                        message.warn('Channel is required')
                    }
                    if(!item.division){
                        if(item.division==='00'){

                        }else{
                            MandatoryData=false
                            message.warn('Division is required')
                        }
                    }
                    if(!item.currency){
                        MandatoryData=false
                        message.warn('Currency is required')
                    }
                    if(!item.partNumber){
                        MandatoryData=false
                        message.warn('Material is required')
                    }
                    if(!item.quantity){
                        MandatoryData=false
                        message.warn('Quantity is required')
                    }
                    if(!item.unitClaimValue){
                        MandatoryData=false
                        message.warn('Unit Claim Value is required')
                    }
                    return item
            })
        }else if(dataSource.length){
            dataSource = dataSource.map((item,index)=>{
                item.createdBy=userId;
                    if(item.reqDeliveryDate){
                        item.reqDeliveryDate = moment(item.reqDeliveryDate).format('YYYY-MM-DD')
                    }else{
                        item.reqDeliveryDate=null
                    }
                    if(item.pricingDate){
                        item.pricingDate = moment(item.pricingDate).format('YYYY-MM-DD')
                    }else{
                        item.pricingDate=null
                    }
                    // if(!item.claimReqNo){
                    //     MandatoryData=false
                    //     message.warn('Claim Request No is required')
                    // }
                    if(!item.comment){
                        MandatoryData=false
                        message.warn('Comment is required')
                    }
                    // if(!item.claimId){
                    //     MandatoryData=false
                    //     message.warn('Claim ID is required')
                    // }
                    // if(!item.claimItemNo){
                    //     MandatoryData=false
                    //     message.warn('Claim Item No is required')
                    // }
                    if(!item.portalReqNo){
                        MandatoryData=false
                        message.warn('Portal Claim Request ID is required')
                    }
                    if(!item.portalReqItem){
                        MandatoryData=false
                        message.warn('Portal Claim Request Item No is required')
                    }
                    if(!item.disputeNo){
                        MandatoryData=false
                        message.warn('Dispute No is required')
                    }
                    if(item.massUpload==='X'){

                    }else{
                        if(!item.disputeItemNo){
                            MandatoryData=false
                            message.warn('Dispute Item No is required')
                        }
                    }
                    if(!item.soldTo){
                        MandatoryData=false
                        message.warn('Sold To Party is required')
                    }
                    if(!item.billTo){
                        MandatoryData=false
                        message.warn('Bill To Party is required')
                    }
                    if(!item.claimType){
                        MandatoryData=false
                        message.warn('Claim Type is required')
                    }
                    if(!item.claimCategory){
                        MandatoryData=false
                        message.warn('Claim Category is required')
                    }
                    if(!item.salesOrg){
                        MandatoryData=false
                        message.warn('Sales Org is required')
                    }
                    if(!item.salesOffice){
                        MandatoryData=false
                        message.warn('Sales Office is required')
                    }
                    if(!item.pricingDate){
                        MandatoryData=false
                        message.warn('Pricing Date is required')
                    }
                    if(!item.channel){
                        MandatoryData=false
                        message.warn('Channel is required')
                    }
                    if(!item.division){
                        if(item.division==='00'){

                        }else{
                            MandatoryData=false
                            message.warn('Division is required')
                        }
                    }
                    if(!item.currency){
                        MandatoryData=false
                        message.warn('Currency is required')
                    }
                    if(!item.partNumber){
                        MandatoryData=false
                        message.warn('Material is required')
                    }
                    if(!item.quantity){
                        MandatoryData=false
                        message.warn('Quantity is required')
                    }
                    if(!item.unitClaimValue){
                        MandatoryData=false
                        message.warn('Unit Claim Value is required')
                    }
                    return item
            })
        }
        let values;
        if(allData.length){
            values={
                action:'',
                claims:errorData.length && errorDataTable?uploadData:allData,
                userId:userId,
                cbso:false
            }
        }else{
            values={
                action:'',
                claims:errorData.length && errorDataTable?uploadData:dataSource,
                userId:userId,
                cbso:false
            }
        }
        if(errorData.length && errorDataTable){
            if(!MandatoryData){
                this.setState({loading:false})
            }
            MandatoryData && claims_save_ecc(values).then(res=>{
                const {retCode,retMsg,data} = res
                if(retCode === "200"){
                    message.success(`${retMsg}`)
                    this.setState({loading:false,dataSource:data,randomNumber:Math.random()})
                }else {
                    message.error(`${retMsg}`)
                    this.setState({loading:false})
                }
            })
        }else{
            if(values.claims.length){
                values.claims = values.claims.map((item)=>{
                    return {
                        ...item,
                        reqDeliveryDate:item.reqDeliveryDate?moment(item.reqDeliveryDate).format('YYYY-MM-DD'):null,
                        pricingDate:item.pricingDate?moment(item.pricingDate).format('YYYY-MM-DD'):null
                    }
                })
            }
            if(!MandatoryData){
                this.setState({loading:false})
            }
            MandatoryData && claims_save_ecc(values).then(res=>{
                const {retCode,retMsg,data} = res
                if(retCode === "200"){
                    message.success(`${retMsg}`)
                    this.setState({loading:false,dataSource:data,randomNumber:Math.random()})
                    // this.onFinish(finishValues)
                }else {
                    message.error(`${retMsg}`)
                    this.setState({loading:false})
                }
            })
        }
    }
    onLocalSava=()=>{
        let {selectedRows,errorData,errorDataTable,uploadData,dataSource} = this.state
        let userId = window.localStorage.getItem('userId')
        this.setState({loading:true})
        let values;
        values={
            action:'',
            claims:errorData.length && errorDataTable?uploadData:selectedRows,
            userId:userId,
            cbso:false
        }
        if(errorData.length && errorDataTable){
            claims_save_local(values).then(res=>{
                const {retCode,retMsg,data} = res
                if(retCode === "200"){
                    message.success(`${retMsg}`)
                    this.setState({loading:false,dataSource:data,randomNumber:Math.random()})
                }else {
                    message.error(`${retMsg}`)
                    this.setState({loading:false})
                }
            })
        }else{
            let MandatoryData=true
            if(selectedRows.length){
                selectedRows.map(item=>{
                    item.createdBy=userId;
                    if(item.reqDeliveryDate){
                        item.reqDeliveryDate = item.reqDeliveryDate?moment(item.reqDeliveryDate).format('YYYY-MM-DD'):''
                    }
                    if(item.pricingDate){
                        item.pricingDate = item.pricingDate?moment(item.pricingDate).format('YYYY-MM-DD'):''
                    }
                    if(item.unitClaimValue<=0){
                        MandatoryData=false
                        message.warn('Claim quantity and Unit claim value should be bigger than zero!')
                    }
                    if(item.claimReqNo){
                        if(!item.claimReqNo){
                            MandatoryData=false
                            message.warn('Claim Request No is required')
                        }
                        if(!item.comment){
                            MandatoryData=false
                            message.warn('Comment is required')
                        }
                        if(!item.claimId){
                            MandatoryData=false
                            message.warn('Claim ID is required')
                        }
                        if(!item.claimItemNo){
                            MandatoryData=false
                            message.warn('Claim Item No is required')
                        }
                        if(!item.portalReqNo){
                            MandatoryData=false
                            message.warn('Portal Claim Request ID is required')
                        }
                        if(!item.portalReqItem){
                            MandatoryData=false
                            message.warn('Portal Claim Request Item No is required')
                        }
                        if(!item.disputeNo){
                            MandatoryData=false
                            message.warn('Dispute No is required')
                        }
                        if(item.massUpload==='X'){

                        }else{
                            if(!item.disputeItemNo){
                                MandatoryData=false
                                message.warn('Dispute Item No is required')
                            }
                        }
                        if(!item.soldTo){
                            MandatoryData=false
                            message.warn('Sold To Party is required')
                        }
                        if(!item.billTo){
                            MandatoryData=false
                            message.warn('Bill To Party is required')
                        }
                        if(!item.claimType){
                            MandatoryData=false
                            message.warn('Claim Type is required')
                        }
                        if(!item.claimCategory){
                            MandatoryData=false
                            message.warn('Claim Category is required')
                        }
                        if(!item.salesOrg){
                            MandatoryData=false
                            message.warn('Sales Org is required')
                        }
                        if(!item.salesOffice){
                            MandatoryData=false
                            message.warn('Sales Office is required')
                        }
                        if(!item.pricingDate){
                            MandatoryData=false
                            message.warn('Pricing Date is required')
                        }
                        if(!item.channel){
                            MandatoryData=false
                            message.warn('Channel is required')
                        }
                        if(!item.division){
                            if(item.division==='00'){

                            }else{
                                MandatoryData=false
                                message.warn('Division is required')
                            }

                        }
                        if(!item.currency){
                            MandatoryData=false
                            message.warn('Currency is required')
                        }
                        if(!item.partNumber){
                            MandatoryData=false
                            message.warn('Material is required')
                        }
                        if(!item.quantity){
                            MandatoryData=false
                            message.warn('Quantity is required')
                        }
                        if(!item.unitClaimValue){
                            MandatoryData=false
                            message.warn('Unit Claim Value is required')
                        }
                    }

                })
            }else if(dataSource.length){
                values={
                    action:'',
                    claims:errorData.length && errorDataTable?uploadData:dataSource.map(item=>{
                        if(item.claimReqNo){
                            if(!item.claimReqNo){
                                MandatoryData=false
                                message.warn('Claim Request No is required')
                            }
                            if(!item.comment){
                                MandatoryData=false
                                message.warn('Comment is required')
                            }
                            if(!item.claimId){
                                MandatoryData=false
                                message.warn('Claim ID is required')
                            }
                            if(!item.claimItemNo){
                                MandatoryData=false
                                message.warn('Claim Item No is required')
                            }
                            if(!item.portalReqNo){
                                MandatoryData=false
                                message.warn('Portal Claim Request ID is required')
                            }
                            if(!item.portalReqItem){
                                MandatoryData=false
                                message.warn('Portal Claim Request Item No is required')
                            }
                            if(!item.disputeNo){
                                MandatoryData=false
                                message.warn('Dispute No is required')
                            }
                            if(item.massUpload==='X'){

                            }else{
                                if(!item.disputeItemNo){
                                    MandatoryData=false
                                    message.warn('Dispute Item No is required')
                                }
                            }
                            if(!item.soldTo){
                                MandatoryData=false
                                message.warn('Sold To Party is required')
                            }
                            if(!item.billTo){
                                MandatoryData=false
                                message.warn('Bill To Party is required')
                            }
                            if(!item.claimType){
                                MandatoryData=false
                                message.warn('Claim Type is required')
                            }
                            if(!item.claimCategory){
                                MandatoryData=false
                                message.warn('Claim Category is required')
                            }
                            if(!item.salesOrg){
                                MandatoryData=false
                                message.warn('Sales Org is required')
                            }
                            if(!item.salesOffice){
                                MandatoryData=false
                                message.warn('Sales Office is required')
                            }
                            if(!item.pricingDate){
                                MandatoryData=false
                                message.warn('Pricing Date is required')
                            }
                            if(!item.channel){
                                MandatoryData=false
                                message.warn('Channel is required')
                            }
                            if(!item.division){
                                if(item.division==='00'){

                                }else{
                                    MandatoryData=false
                                    message.warn('Division is required')
                                }
                            }
                            if(!item.currency){
                                MandatoryData=false
                                message.warn('Currency is required')
                            }
                            if(!item.partNumber){
                                MandatoryData=false
                                message.warn('Material is required')
                            }
                            if(!item.quantity){
                                MandatoryData=false
                                message.warn('Quantity is required')
                            }
                            if(!item.unitClaimValue){
                                MandatoryData=false
                                message.warn('Unit Claim Value is required')
                            }
                        }
                        return {
                            ...item,
                            createdBy:userId,
                            reqDeliveryDate:item.reqDeliveryDate?moment(item.reqDeliveryDate).format('YYYY-MM-DD'):null,
                            pricingDate:item.pricingDate?moment(item.pricingDate).format('YYYY-MM-DD'):null
                        }
                    }),
                    userId:userId,
                    cbso:false
                }
            }else{
                MandatoryData=false
                this.setState({loading:false})
                message.warn('')
            }
            if(!MandatoryData){
                this.setState({loading:false})
            }
            MandatoryData && claims_save_local(values).then(res=>{
                const {retCode,retMsg,data} = res
                if(retCode === "200"){
                    message.success(`${retMsg}`)
                    this.setState({loading:false,dataSource:data,randomNumber:Math.random()})
                }else {
                    message.error(`${retMsg}`)
                    this.setState({loading:false,dataSource:data,randomNumber:Math.random()})
                }
            })
        }
    }
    saveData=(data,allData)=>{
        this.setState({selectedRows:data,allData:allData})
    }
    // allData=(data)=>{
    //     this.setState({allData:data})
    // }
    dataFromChange=(value)=>{
        let disputeNo = this.formRef.current.getFieldValue('disputeNo')
        let poNumber = this.formRef.current.getFieldValue('poNumber')
        let bpReference = this.formRef.current.getFieldValue('bpReference')
        let claimId = this.formRef.current.getFieldValue('claimId')
        let claimType = this.formRef.current.getFieldValue('claimType')
        let claimCategory = this.formRef.current.getFieldValue('claimCategory')
        let invoiceNo = this.formRef.current.getFieldValue('invoiceNo')
        let date1 = Date.parse(value);
        let data2 = Date.parse(this.formRef.current.getFieldValue('createdOnTo'))
        let timeDiff = Math.abs(data2 - date1);
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if(diffDays>14){
            this.setState({diffDaysError:true})
            if(disputeNo || poNumber || bpReference || claimId || claimType || claimCategory || invoiceNo){

            }else{
                message.warn('More search criteria is needed when the creation date period is lager then two weeks!')
            }
        }else{
            this.setState({diffDaysError:false})
        }
    }
    dataToChange=(value)=>{
        let disputeNo = this.formRef.current.getFieldValue('disputeNo')
        let poNumber = this.formRef.current.getFieldValue('poNumber')
        let bpReference = this.formRef.current.getFieldValue('bpReference')
        let claimId = this.formRef.current.getFieldValue('claimId')
        let claimType = this.formRef.current.getFieldValue('claimType')
        let claimCategory = this.formRef.current.getFieldValue('claimCategory')
        let invoiceNo = this.formRef.current.getFieldValue('invoiceNo')
        let date1 = Date.parse(value);
        let data2 = Date.parse(this.formRef.current.getFieldValue('createdOnFrom'))
        let timeDiff = Math.abs(date1 - data2);
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        // console.log(diffDays);
        if(diffDays>14){
            this.setState({diffDaysError:true})
            if(disputeNo || poNumber || bpReference || claimId || claimType || claimCategory || invoiceNo){

            }else{
                message.warn('More search criteria is needed when the creation date period is lager then two weeks!')
            }
        }else{
            this.setState({diffDaysError:false})
        }
    }
    onFinish = (values) => {
        const {diffDaysError} = this.state;
        this.setState({loading:true,disabled:false,allData:[],selectedRows:[]})
        let createdOnFrom = values.createdOnFrom?(moment(values.createdOnFrom).format('YYYY-MM-DD')):undefined;
        let createdOnTo = values.createdOnTo?(moment(values.createdOnTo).format('YYYY-MM-DD')):undefined;
        let status = values.status && values.status.length?values.status:['LFCRA','FCRAF','FCRAT','LFCHA','FCHAF','FCHAN','FAPPF']
        if(!Array.isArray(values.disputeNo)){
            values.disputeNo = values.disputeNo?values.disputeNo.split(','):undefined
        }
        values = {
            ...values,
            createdOnFrom:createdOnFrom.split('-').join('') + '000000',
            createdOnTo:createdOnTo.split('-').join('') + '235959',
            status:status,
            cbso:false
        }
        if(diffDaysError){
            if(values.disputeNo || values.poNumber || values.bpReference || values.claimId || values.claimType || values.claimCategory || values.invoiceNo){
                claims_search(values).then((res)=>{
                    let {data,retCode,retMsg} = res;
                    if(retCode==="200"){
                        this.setState({loading:false,errorData:[],errorDataTable:false,dataSource:data,selectedRows:[],randomNumber:Math.random()})
                    }else{
                        message.error(`${retMsg}`)
                        this.setState({loading:false})
                    }
                })
            }else{
                message.warn('More search criteria is needed when the creation date period is lager then two weeks!')
                this.setState({loading:false})
            }
        }else {
            claims_search(values).then((res)=>{
                let {data,retCode,retMsg} = res;
                if(retCode==="200"){
                    this.setState({loading:false,errorData:[],errorDataTable:false,dataSource:data,selectedRows:[],randomNumber:Math.random()})
                }else{
                    message.error(`${retMsg}`)
                    this.setState({loading:false})
                }
            })
        }

    }
    dpSplit=(e)=>{
        let value = e.target.value
        if (value.indexOf(" ") == -1) {

        } else {
            if(value){
                this.formRef.current.setFieldsValue({disputeNo:value.trim().split(/\s+/)})
            }
        }
    }
    onMarkDeletionAll=()=>{
        let {dataSource} = this.state;
        if(dataSource.length){
            this.setState({isModalVisible:true})
        }
    }
    handleOk=()=>{
        this.setState({isModalVisible:false})
        let {dataSource} = this.state;
        let newData=[]
        dataSource = dataSource.length && dataSource.every(item=>{
            if(item.claimId){
                message.warn(" 'Mark Deletion All' only applies to the draft auto-generated claim records.")
                return false
            }else{
                newData.push({
                    ...item,
                    deleteStatus:'X'
                })
                return true
            }
        })
        if(dataSource){
            this.setState({disabled:true,dataSource:newData,randomNumber:Math.random()})
        }
    }
    handleCancel=()=>{
        this.setState({isModalVisible:false})
    }
    render() {
        const { disabled,isModalVisible,errorDataTable,basic_info,randomNumber,errorData,dataSource,loading} = this.state;
        return <div>
            <HeaderNav parmas={'/singleFinancialClaimSearch'}/>
            <Layout className="site-layout-background singleFinancialClaimEdit" style={{ padding: '24px 0',margin: '0 auto' }}>
                <div className="example" style={{display:loading?'block':'none'}}>
                    <Spin spinning={loading} />
                </div>
                <Modal
                       width={400}
                       visible={isModalVisible}
                       onOk={this.handleOk}
                       onCancel={this.handleCancel}
                       destroyOnClose={true}
                >
                    <p>All the claim records will be marked as deleted, and the changes cannot be reversed after clicking "Save Local" button.  </p>
                </Modal>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1 style={{marginLeft:'4%'}}>Edit Financial Claim</h1>
                    <Form
                        name="internal"
                        labelCol={{ span:13 }}
                        wrapperCol={{ span: 11}}
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Number"
                                    name="disputeNo"
                                    tooltip={'Dispute No can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={this.dpSplit} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Po Number"
                                    name="poNumber"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Request No"
                                    name="claimReqNo"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="BP-Reference"
                                    name="bpReference"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim ID"
                                    name="claimId"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to Party"
                                    name="soldTo"
                                    rules={[{ required: false}]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Type"
                                    name="claimType"
                                    rules={[{ required: false }]}

                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'} showSearch optionFilterProp="children">
                                        {
                                            basic_info?basic_info.claimTypeList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Invoice No"
                                    name="invoiceNo"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Category"
                                    name="claimCategory"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'} showSearch optionFilterProp="children">
                                        {
                                            basic_info?basic_info.claimCategoryList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create From"
                                    name="createdOnFrom"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker onChange={this.dataFromChange} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create To"
                                    name="createdOnTo"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker onChange={this.dataToChange} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Org"
                                    name="salesOrg"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'} showSearch optionFilterProp="children">
                                        {
                                            basic_info?basic_info.salesOrgList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Created By"
                                    name="createdBy"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Office"
                                    name="salesOffice"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'} showSearch optionFilterProp="children">
                                        {
                                            basic_info?basic_info.salesOfficeList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Status"
                                    name="status"
                                    rules={[{ required: false }]}
                                >
                                    <Select mode="tags" dropdownMatchSelectWidth={240} placeholder={'Please select'} showSearch optionFilterProp="children">
                                        <Option value={'LFCRA'} >Local financial claim request created	</Option>
                                        <Option value={'FCRAF'} >Financial claim create failed</Option>
                                        <Option value={'FCRAT'} >Financial claim created</Option>
                                        <Option value={'LFCHA'} >Local Financial claim request changed</Option>
                                        <Option value={'FCHAF'} >Financial claim change failed</Option>
                                        <Option value={'FCHAN'} >Financial claim changed</Option>
                                        <Option value={'FAPPF'} >Financial claim approve failed</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={10} offset={14}>
                                <Space style={{marginBottom:20,float:'right'}}>
                                    {/*<Button type="primary" onClick={this.downloadExcel}>*/}
                                    {/*    Download*/}
                                    {/*</Button>*/}
                                    {/*<Upload {...this.UploadProps()}>*/}
                                    {/*    <Button icon={<UploadOutlined />}>Upload</Button>*/}
                                    {/*</Upload>*/}
                                    <Button type="primary" onClick={this.onMarkDeletionAll}>
                                        Mark Deletion All
                                    </Button>
                                    <Button type="primary" disabled={disabled} onClick={this.onEccSave}>
                                        Submit to ECC
                                    </Button>
                                    <Button type="primary" onClick={this.onLocalSava}>
                                        Save Local
                                    </Button>
                                    <Button type="primary" htmlType="submit">
                                        Search
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form>
                    {errorDataTable && errorData.length?
                        <Table
                            style={{paddingRight: 24}}
                            bordered
                            dataSource={errorData}
                            columns={[
                                {title:'Line',dataIndex:'line'},
                                {title:'Column Name',dataIndex:'name'},
                                {title:'Description',dataIndex:'des'},
                            ]}
                        />:''
                    }
                    {dataSource.length && !errorDataTable ? <EditableTable
                        dataSource={dataSource}
                        saveData={this.saveData.bind(this)}
                        // allData={this.allData.bind(this)}
                        randomNumber={randomNumber}
                        basic_info={basic_info}/>:''}
                </Content>
            </Layout>
        </div>
    }
}

export default SingleFinancialClaimSearch;